"use client";

import { useEffect } from "react";

import { resetToMain } from "@repo/store";
import { useDispatch } from "react-redux";

/**
 * Component that resets the Redux store on initial page load.
 * Should be placed at the root of the application.
 * Clears all booking-related data but preserves auth and locale.
 */
export function ReduxCleaner() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Dispatch the resetToMain action on component mount
    // This clears all booking data but keeps auth and locale
    dispatch(resetToMain());
  }, [dispatch]);

  return null; // This component doesn't render anything
}
